import { Component, Input } from '@angular/core';

/** Panel for design sections that have no backend yet: keeps the layout, shows a "Coming soon" state. */
@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrl: './coming-soon.component.css',
  standalone: false,
})
export class ComingSoonComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() icon = 'hourglass_top';
  /** Body height in px (keeps the grid proportions of the design). */
  @Input() height = 160;
  /** Render without the panel chrome (for use inside an existing panel). */
  @Input() bare = false;
}
